<template>
  <div class="neg-pad">
    <div class="billing-header">
      <div class="level is-mobile header-level">
        <div class="level-left">
          <div class="level-item">
            <h1>Billing</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <tooltip-new :v2="true" iconAlign="middle" :isClickAway="true" hyper-link="https://intercom.help/hellopeter/en/collections/2645584-hellopeter-plans-and-billing">&nbsp;&nbsp;About this feature</tooltip-new>
          </div>
        </div>
      </div>
    </div>
    <!-- PLAN -->
    <div v-if="showSpinner" class="columns">
      <div class="column is-12 is-margin-top-40">
        <p class="has-text-centered">
          <img src="/static/img/loaders/ajax-loader.gif" alt="Verifying registration..."/>
        </p>
      </div>
    </div>
    <div v-if="!showSpinner" class="billing-section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="bs-head">Current&nbsp;plan</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <p v-if="isFreeTrial" class="has-text-centered">
              <a @click.prevent="cancelFreeTrial" href="#" class="bs-link">Cancel&nbsp;plan</a>
              <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
              <a :href="`/billing/edit-plan/${getLowercasePlanName}/${getSubscriptionCycle}`" class="bs-link">Edit&nbsp;plan</a>
            </p>
            <a v-else :href="`/billing/edit-plan/${getLowercasePlanName}/${getSubscriptionCycle}`" class="bs-link">Edit&nbsp;plan</a>
          </div>
        </div>
      </div>
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left has-text-weight-bold" v-html="currentPlanName"></p>
          </div>
        </div>
        <div class="level-right is-hidden-mobile">
          <div class="level-item">
            <p class="has-text-right" v-html="getPlanRenews"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left is-hidden-mobile" v-html="getPlanLimits"></p>
            <p class="has-text-left is-hidden-tablet" v-html="getPlanLimitsMobile"></p>
          </div>
        </div>
        <div class="level-right is-hidden-mobile">
          <div class="level-item">
            <p class="has-text-right" v-html="getPlanCostAndFrequency"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile is-hidden-tablet">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left mar-top-20" v-html="getPlanRenews"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile is-hidden-tablet">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left" v-html="getPlanCostAndFrequency"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Add ons -->
    <div v-if="subscriptionCanPurchaseAddOns && !showSpinner" class="billing-section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="bs-head">Available&nbsp;Add-ons</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a v-if="enabledPayNow" @click.prevent="purchaseCreditsAndOrInvites(addOnCredits, addOnInvites)" href="#" class="bs-link">Pay&nbsp;now</a>
            <a v-if="!enabledPayNow" @click.prevent="nothing" href="#" class="bs-link nothing">Pay&nbsp;now</a>
          </div>
        </div>
      </div>
      <div class="level is-mobile has-input">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left is-hidden-mobile"><span class="has-text-weight-bold">Review&nbsp;credits</span><br/>A review credit enables you to reply to a review and access customer data for each review where the source of the review
              is not from a review invitation.</p>
            <p class="has-text-left is-hidden-tablet"><span class="has-text-weight-bold">Review&nbsp;credits</span></p>
          </div>
          <div class="level-item is-hidden-tablet">
            <tooltip-new :v2="true" :mobile-image-align="isClickAway" content-width="170px">A review credit enables you to reply to a review and access customer data for each review where the source of the review is not from a review invitation.
            </tooltip-new>
          </div>
        </div>
        <div class="level-right is-hidden-mobile">
          <div class="level-item">
            <input @input="filterInput" v-model="addOnCredits" class="input_credits" type="text" placeholder="0" name="review_credits" value="0"/>
          </div>
          <div class="level-item">
            <p class="has-text-right credit_cost" v-html="getReviewCreditTotalCost"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile has-input is-hidden-tablet">
        <div class="level-left">
          <div class="level-item">
            <input @input="filterInput" v-model="addOnCredits" class="input_credits" type="text" placeholder="0" name="review_credits" value="0"/>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <p class="has-text-right credit_cost" v-html="getReviewCreditTotalCost"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile has-input">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left is-hidden-mobile"><span class="has-text-weight-bold">Review&nbsp;invitation&nbsp;credits</span><br/>A review invitation allows you to easily collect reviews using smart email and SMS technology.</p>
            <p class="has-text-left is-hidden-tablet"><span class="has-text-weight-bold">Review&nbsp;invitation&nbsp;credits</span></p>
          </div>
          <div class="level-item is-hidden-tablet">
            <tooltip-new :v2="true" :mobile-image-align="isClickAway" content-width="170px">A review invitation allows you to easily collect reviews using smart email and SMS technology.</tooltip-new>
          </div>
        </div>
        <div class="level-right is-hidden-mobile">
          <div class="level-item">
            <input @input="filterInput" v-model="addOnInvites" class="input_credits" type="text" placeholder="0" name="review_credits"/>
          </div>
          <div class="level-item">
            <p class="has-text-right credit_cost" v-html="getInviteCreditTotalCost"></p>
          </div>
        </div>
      </div>
      <div class="level is-mobile has-input is-hidden-tablet">
        <div class="level-left">
          <div class="level-item">
            <input @input="filterInput" v-model="addOnInvites" class="input_credits" type="text" placeholder="0" name="review_credits"/>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <p class="has-text-right credit_cost" v-html="getInviteCreditTotalCost"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- CREDIT CARD DETAILS -->
    <div v-if="hasCreditCardDetails && !showSpinner" class="billing-section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="bs-head">Credit&nbsp;card&nbsp;details</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a href="#" @click.prevent="showCreditCardModal" class="bs-link">Edit</a>
          </div>
        </div>
      </div>
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left" v-html="getCreditCardHolder"></p>
          </div>
          <div class="level-item">
            <p class="has-text-left" v-html="getCreditCardDetails"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- BILLING INFORMATION -->
    <div v-if="!showSpinner" class="billing-section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="bs-head">Billing&nbsp;information</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a @click.prevent="showBillingDetailsModal" href="#" class="bs-link">Edit</a>
          </div>
        </div>
      </div>
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="has-text-left" v-html="getBillingContactName"></p>
          </div>
          <div class="level-item">
            <p class="has-text-left" v-html="getBillingContactEmail"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- INVOICES -->
    <div v-if="!showSpinner" class="billing-section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="bs-head">Invoices</p>
          </div>
        </div>
        <div class="level-right is-hidden-mobile">
          <div class="level-item">
            <!--            <a href="#" class="bs-link">Download&nbsp;all</a>-->
          </div>
        </div>
      </div>
      <div v-if="fetching_billing" class="columns">
        <div class="column is-12 is-margin-top-40">
          <p class="has-text-centered">
            <img src="/static/img/loaders/ajax-loader.gif" alt="Fetching invoices..."/>
          </p>
        </div>
      </div>
      <table v-if="!fetching_billing" class="table is-fullwidth">
        <thead>
        <tr>
          <td>Date</td>
          <td>Reference</td>
          <td>Status</td>
          <td class="is-hidden-mobile">Amount</td>
          <td>&nbsp;</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(inv, index) in items" :key="index">
          <td v-html="inv.updated_at_date"></td>
          <td v-html="inv.payment_reference"></td>
          <td class="is-hidden-mobile" v-if="inv.payment_status === 'PENDING'">PENDING&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a class="bs-link" :href="`/billing/checkout/${inv.id}`">Pay now</a></td>
          <td class="is-hidden-tablet" v-if="inv.payment_status === 'PENDING'"><a class="bs-link" :href="`/billing/checkout/${inv.id}`">Pay&nbsp;now</a></td>
          <td v-if="inv.payment_status !== 'PENDING'" v-html="inv.payment_status"></td>
          <td class="is-hidden-mobile">R{{ getFormattedPrice(inv) }}</td>
          <td class="has-text-right"><a :href="`${api_url}/invoices/${inv.id}/file`" class="bs-link">Download</a></td>
        </tr>
        </tbody>
      </table>
      <paginator :dataSet="dataSet" @changed="getBillingHistory"></paginator>
      <!-- Credit Card Modal -->
      <div :class="['modal is-hidden-mobile', { 'is-active' : creditCardModalShow }]">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-centered">Credit card details</p>
            <button @click="closeCreditCardModal" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">
            <form>
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <label class="label">Card holder name</label>
                  <input v-model="cForm.selected_cc_name" class="input" type="text" placeholder="Card holder name"/>
                </div>
                <div class="control">
                  <label class="label">Credit card number</label>
                  <input class="input" type="text" v-model="cForm.selected_cc_number" placeholder="Credit card number"/>
                </div>
              </div>
              <div class="field is-grouped">
                <div class="control">
                  <label class="label">Month</label>
                  <custom-drop-down @changed="setCreditCardMonth" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Month" dropdown-name="credit_card_month" :items="months"></custom-drop-down>
                </div>
                <div class="control">
                  <label class="label">Year</label>
                  <custom-drop-down @changed="setCreditCardYear" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Year" dropdown-name="credit_card_year" :items="years"></custom-drop-down>
                </div>
                <div class="control cc_info">
                  <label class="label">CVV</label>
                  <input class="input cc_field" v-model="cForm.selected_cc_ccv" type="text" placeholder="CVV"/>
                  <tooltip-new :v2="true" class="rel-pos" content-width="160px">The last 3 digits at the back of your card</tooltip-new>
                </div>
                <div class="control">
                  <label class="label">&nbsp;</label>
                  <div class="level is-mobile">
                    <div class="level-right">
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png"/>
                      </div>
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x"
                             src="/static/img/creditcard/mastercard.png"/>
                      </div>
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x"
                             src="/static/img/creditcard/amex.png"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <footer class="modal-card-foot buttons is-centered">
            <!-- <div class="dummy-msg-warning-"> -->
            <!--   <span>!</span><p>R1 will be debited from your card for pre-authorisation.</p> -->
            <!-- </div> -->
            <button @click.prevent="saveCreditCardDetails" :disabled="isSavingCreditCardDetails" :class="['button solid-btn', { 'is-loading' : isSavingCreditCardDetails }]">PROCEED</button>
          </footer>
        </div>
      </div>
      <div :class="['modal is-hidden-tablet', { 'is-active' : creditCardModalShow }]">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-centered">Credit card details</p>
            <button @click="closeCreditCardModal" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">
            <form>
              <div class="field">
                <div class="control">
                  <label class="label">Card holder name</label>
                  <input v-model="cForm.selected_cc_name" class="input" type="text" placeholder="Card holder name"/>
                </div>
              </div>
              <div class="field ">
                <div class="control">
                  <label class="label">Credit card number</label>
                  <input class="input" type="text" v-model="cForm.selected_cc_number" placeholder="Credit card number"/>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Month</label>
                  <custom-drop-down :small-content-height="smallCreditCardMonthContentView" :full-width="small_credit_card" @changed="setCreditCardMonth" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Month"
                                    dropdown-name="credit_card_month" :items="months"></custom-drop-down>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Year</label>
                  <custom-drop-down :full-width="small_credit_card" @changed="setCreditCardYear" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Year" dropdown-name="credit_card_year" :items="years"></custom-drop-down>
                </div>
              </div>
              <div class="field">
                <div class="control cc_info">
                  <label class="label">CVV</label>
                  <input class="input cc_field" v-model="cForm.selected_cc_ccv" type="text" placeholder="CVV"/>
                  <tooltip-new class="rel-pos" content-width="160px" :v2="true">The last 3 digits at the back of your card</tooltip-new>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">&nbsp;</label>
                  <div class="level is-mobile">
                    <div class="level-right">
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png"/>
                      </div>
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x"
                             src="/static/img/creditcard/mastercard.png"/>
                      </div>
                      <div class="level-item">
                        <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x"
                             src="/static/img/creditcard/amex.png"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <footer class="modal-card-foot buttons is-centered">
            <button @click.prevent="saveCreditCardDetails" :disabled="isSavingCreditCardDetails" :class="['button solid-btn', { 'is-loading' : isSavingCreditCardDetails }]">SAVE</button>
          </footer>
        </div>
      </div>
      <!-- Billing Information Modal -->
      <div :class="['modal', { 'is-active' : billingDetailsModalShow }]">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-centered">Billing information</p>
            <button @click="closeBillingDetailsModal" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body is-hidden-mobile">
            <form>
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <label class="label">First name</label>
                  <input v-model="bForm.first_name" class="input" type="text" placeholder="First name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_person')" v-text="bForm.errors.get('contact_person')"></p>
                </div>
                <div class="control">
                  <label class="label">Last name</label>
                  <input class="input" type="text" v-model="bForm.last_name" placeholder="Last name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_person')" v-text="bForm.errors.get('contact_person')"></p>
                </div>
              </div>
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <label class="label">Email address</label>
                  <input v-model="bForm.contact_email" class="input" type="text" placeholder="Email address"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_email')" v-text="bForm.errors.get('contact_email')"></p>
                </div>
                <div class="control">
                  <label class="label">Phone number</label>
                  <input class="input" type="text" v-model="bForm.phone" placeholder="Phone number"/>
                </div>
              </div>
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <label class="label">Registered business name</label>
                  <input v-model="bForm.business_reg_name" class="input" type="text" placeholder="Registered business name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_reg_name')" v-text="bForm.errors.get('business_reg_name')"></p>
                </div>
                <div class="control">
                  <label class="label">Address</label>
                  <input class="input" type="text" v-model="bForm.address" placeholder="Address"/>
                  <p class="help is-danger" v-if="bForm.errors.has('address')" v-text="bForm.errors.get('address')"></p>
                </div>
              </div>
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <label class="label">Registration number (optional)</label>
                  <input v-model="bForm.business_reg_number" class="input" type="text" placeholder="Registration number (optional)"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_reg_number')" v-text="bForm.errors.get('business_reg_number')"></p>
                </div>
                <div class="control">
                  <label class="label">VAT number (optional)</label>
                  <input class="input" type="text" v-model="bForm.business_vat_number" placeholder="VAT number (optional)"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_vat_number')" v-text="bForm.errors.get('business_vat_number')"></p>
                </div>
              </div>

            </form>
          </section>
          <section class="modal-card-body is-hidden-tablet">
            <form>
              <div class="field">
                <div class="control">
                  <label class="label">First name</label>
                  <input v-model="bForm.first_name" class="input" type="text" placeholder="First name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_person')" v-text="bForm.errors.get('contact_person')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Last name</label>
                  <input class="input" type="text" v-model="bForm.last_name" placeholder="Last name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_person')" v-text="bForm.errors.get('contact_person')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Email address</label>
                  <input v-model="bForm.contact_email" class="input" type="text" placeholder="Email address"/>
                  <p class="help is-danger" v-if="bForm.errors.has('contact_email')" v-text="bForm.errors.get('contact_email')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Phone number</label>
                  <input class="input" type="text" v-model="bForm.phone" placeholder="Phone number"/>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Registered business name</label>
                  <input v-model="bForm.business_reg_name" class="input" type="text" placeholder="Registered business name"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_reg_name')" v-text="bForm.errors.get('business_reg_name')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Address</label>
                  <input class="input" type="text" v-model="bForm.address" placeholder="Address"/>
                  <p class="help is-danger" v-if="bForm.errors.has('address')" v-text="bForm.errors.get('address')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Registration number (optional)</label>
                  <input v-model="bForm.business_reg_number" class="input" type="text" placeholder="Registration number (optional)"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_reg_number')" v-text="bForm.errors.get('business_reg_number')"></p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">VAT number (optional)</label>
                  <input class="input" type="text" v-model="bForm.business_vat_number" placeholder="VAT number (optional)"/>
                  <p class="help is-danger" v-if="bForm.errors.has('business_vat_number')" v-text="bForm.errors.get('business_vat_number')"></p>
                </div>
              </div>

            </form>
          </section>
          <footer class="modal-card-foot buttons is-centered">
            <button :disabled="isSavingBillingDetails" @click.prevent="saveBillingDetails" :class="['button solid-btn', { 'is-loading' : isSavingBillingDetails }]">SAVE</button>
          </footer>
        </div>
      </div>
    </div>
    <form class="is-invisible" name="forwardToRegisterNewBillingGateway" v-if="(redirectParams.length > 0 || redirectAction.length > 0) && !showSpinner" method="post" :action="redirectAction" target="_self">
      <p>Please have your phone ready to obtain a One Time Pin</p>
      <input v-for="param in redirectParams" :name="param.name" :value="param.value" :key="param.name" type="hidden"/>
      <input type="submit" class="button is-button-blue-outline is-fullwidth" value="Click here to continue"/>
    </form>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import misc from './../../../mixins/misc.js'
import ApiResource from '../../../api/ApiResource'
import Paginator from './../../../components/Paginator'
import TooltipNew from '../../../widgets/TooltipNew'
import CustomDropDown from './../../../components/DropDownBilling'
import moment from 'moment'

export default {
  name: 'BillingIndex',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Billing'
  },
  components: {
    TooltipNew,
    CustomDropDown,
    Paginator
  },
  mixins: [misc],
  data () {
    return {
      smallCreditCardMonthContentView: true,
      showSpinner: false,
      enabledPayNow: false,
      isClickAway: true,
      addOnCredits: 0,
      addOnInvites: 0,
      billingContact: undefined,
      subscription: undefined,
      subscriptionCost: '0.00',
      subscriptionCycle: 'monthly',
      subscriptionCanPurchaseAddOns: false,
      subscriptionReviewCost: 0.00,
      subscriptionInviteCost: 0.00,
      payment_plan: undefined,
      reviewLimit: 0,
      inviteLimit: 0,
      replyLimit: 0,
      creditCardModalShow: false,
      billingDetailsModalShow: false,
      small_credit_card: true,
      isSavingCreditCardDetails: false,
      isSavingBillingDetails: false,
      bForm: new ApiResource({
        first_name: '',
        last_name: '',
        contact_person: '',
        contact_email: '',
        phone: '',
        business_reg_name: '',
        address: '',
        business_reg_number: '',
        business_vat_number: ''
      }),
      card_number: '',
      months: [
        {name: '01', value: '01'},
        {name: '02', value: '02'},
        {name: '03', value: '03'},
        {name: '04', value: '04'},
        {name: '05', value: '05'},
        {name: '06', value: '06'},
        {name: '07', value: '07'},
        {name: '08', value: '08'},
        {name: '09', value: '09'},
        {name: '10', value: '10'},
        {name: '11', value: '11'},
        {name: '12', value: '12'}
      ],
      years: [],
      cForm: new ApiResource({
        address: '',
        selected_cc_month: '',
        selected_cc_year: '',
        selected_cc_ccv: '',
        selected_cc_name: '',
        selected_cc_number: '',
        selected_cc_type: '',
        card_return_url: '',
        language: navigator.language,
        screenHeight: screen.height,
        screenWidth: screen.width,
        timezone: new Date().getTimezoneOffset(),
        javaEnabled: navigator.javaEnabled,
        ip: '',
        city: '',
        country: 'ZA',
        postcode: '7800',
        email: localStorage.getItem('email')
      }),
      cancelTrialForm: new ApiResource(),
      tooltipQuestion: true,
      invoices: [
        {
          date: '30/10/20',
          reference: 'HP703029',
          status: 'PENDING',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703030',
          status: 'PENDING',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703031',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703032',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703033',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703034',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703035',
          status: 'PENDING',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703036',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703037',
          status: 'PAID',
          amount: 'R1,789.34'
        },
        {
          date: '30/10/20',
          reference: 'HP703038',
          status: 'PAID',
          amount: 'R1,789.34'
        }
      ],
      business_slug: localStorage.getItem('org_slug'),
      org_id: localStorage.getItem('org_id'),
      billing_history: {},
      fetching_billing: false,
      dataSet: false,
      bills_per_page: undefined,
      total_records: 0,
      items: 0,
      api_url: process.env.API_URL,
      redirectParams: [],
      redirectAction: ''
    }
  },
  mounted () {
    if (this.$route.query['id'] !== undefined) {
      this.showCreditCardProcessing()
    }
    let yr = []
    const currentYear = new Date().getFullYear()
    for (let i = 0; i < 11; i++) {
      const currentValue = (i + currentYear).toString()
      yr.push({name: currentValue, value: currentValue})
    }
    this.years = yr
    this.getBillingAndSubscriptionDetails()
    this.getBillingHistory(null)
    window.events.$emit('loadHeaderStats')
  },
  created () {
    let locAxios = axios.create({
      baseURL: 'https://ipinfo.io'
    })
    locAxios.get('/json')
        .then(({data}) => {
          console.log('ipinfo result', data)
          if (typeof data.ip !== 'undefined') {
            this.cForm.ip = data.ip
          }

          if (typeof data.city !== 'undefined') {
            this.cForm.city = data.city
          }

          if (typeof data.country !== 'undefined') {
            this.cForm.country = data.country
          }

          if (typeof data.postal !== 'undefined') {
            this.cForm.post_code = data.postal
          }

          const l = JSON.parse(localStorage.getItem('billingDetails'))
          if (typeof l !== 'undefined' && typeof l.billing_details !== 'undefined' && typeof l.billing_details.billing_address !== 'undefined') {
            this.cForm.address = l.billing_details.billing_address
          }
        })
  },
  methods: {
    showCreditCardProcessing () {
      this.showSpinner = true
      const paymentToken = this.$route.query['id']
      const verifyTokenUrl = `/billing/verify-credit-card-payment/null/${paymentToken}?org_id=${this.org_id}`

      axios.get(verifyTokenUrl)
          .then((response) => {
            console.log('payment response', response)
            this.showSpinner = false
            if (response.data.paymentVerification.payment_successful) {
              flash('Successfully updated credit card details')
            } else {
              const errorMessage = response.data.paymentVerification.result.description
              flash(errorMessage, 'is-danger', false)
            }
          })
          .catch(() => {
            const errorMessage = 'error verifying credit card registration'
            flash(errorMessage, 'is-danger', false)
            this.showSpinner = false
          })
    },
    cancelFreeTrial () {
      this.cancelTrialForm.send(`/billing/${this.business_slug}/cancel-plan`)
          .then(() => {
            this.$router.push('/login')
            setTimeout(() => {
              window.location.reload(true)
            }, 1000)
          })
          .catch((error) => {
            console.log('cancel trial error', error)
            flash(error.message, 'is-danger', false)
          })
    },
    saveCreditCardDetails () {
      this.isSavingCreditCardDetails = true
      this.cForm.errors.clear()
      const currentRoute = this.$route.path
      this.cForm.card_return_url = location.origin + currentRoute
      if (!currentRoute.endsWith('/')) {
        this.cForm.card_return_url += '/'
      }
      if (this.cForm.address.length === 0) {
        if (typeof this.userInfo !== 'undefined' && this.userInfo.billing_details !== 'undefined' && this.userInfo.billing_details.billing_address !== 'undefined') {
          this.cForm.address = this.userInfo.billing_details.billing_address
        }
      }
      this.cForm.send(`/billing/register-card/${this.org_id}`)
          .then((data) => {
            if (typeof data.result.redirect !== 'undefined') {
              this.redirectParams = data.result.redirect.parameters
              this.redirectAction = data.result.redirect.url
              setTimeout(() => {
                document.forms['forwardToRegisterNewBillingGateway'].submit()
              }, 200)
            } else {
              this.isSavingCreditCardDetails = false
              this.creditCardModalShow = false
              flash('Error Validating Credit Card Details', 'is-danger', false)
              // setTimeout(() => {
              //   window.location.reload(true)
              // }, 1000)
            }
          })
          .catch((error) => {
            this.isSavingCreditCardDetails = false
            const errorMessage = error.message
            flash(errorMessage, 'is-danger', false)
            console.log('error', error)
          })
    },
    saveBillingDetails () {
      // post to /{slug}/billing-details
      this.bForm.errors.clear()
      this.bForm.contact_person = `${this.bForm.first_name} ${this.bForm.last_name}`
      this.bForm.send(`/${this.business_slug}/billing-details`)
          .then((response) => {
            this.billingContact.name = response.billingInfo.contact_person
            this.billingContact.email = response.billingInfo.contact_email
            this.billingDetailsModalShow = false
          })
          .catch((error) => {
            console.log('error', error)
          })
    },
    /**
     * Makes an api call to get list billing history for org
     * @param {number | null} page to return data from
     * @returns {void}
     */
    getBillingHistory (page) {
      this.billing_history = {}
      this.fetching_billing = true
      axios.get(this.url(page))
          .then((history) => {
            this.bills_per_page = history.data.per_page
            this.fetching_billing = false
            this.refresh(history)
            window.scrollTo(0, 0)
          })
          .catch(() => {
            this.fetching_billing = false
          })
    },
    url (page) {
      if (!page) {
        let query = location.search.match(/page=(\d+)/)

        page = query ? query[1] : 1
      }
      return `/${this.business_slug}/billing-history?page=${page}`
    },
    filterInput (e) {
      e.target.value = e.target.value.replace(/[^0-9]+/g, '')
    },
    setCreditCardMonth (e) {
      this.cForm.selected_cc_month = e.value
    },
    setCreditCardYear (e) {
      this.cForm.selected_cc_year = e.value
    },
    closeCreditCardModal () {
      this.creditCardModalShow = false
    },
    showCreditCardModal () {
      this.creditCardModalShow = true
    },
    closeBillingDetailsModal () {
      this.billingDetailsModalShow = false
    },
    showBillingDetailsModal () {
      this.billingDetailsModalShow = true
    },
    getBillingAndSubscriptionDetails () {
      const businessSlug = localStorage.getItem('org_slug')
      axios.get(`/${businessSlug}/billing-details`)
          .then(({data}) => {
            localStorage.setItem('billingDetails', JSON.stringify(data))
            this.userInfo = JSON.parse(localStorage.getItem('billingDetails'))
            this.billingContact = data.contact_person
            if (typeof this.billingContact !== 'undefined') {
              this.bForm.contact_email = this.billingContact.email
              this.bForm.first_name = this.billingContact.name
            }
            this.subscription = data.subscription
            if (typeof data.subscription !== 'undefined') {
              this.subscriptionCycle = data.subscription.cycle
            }
            if (typeof data.payment_plan !== 'undefined') {
              this.payment_plan = data.payment_plan
            }
            if (typeof this.subscription.lineItems !== 'undefined' && this.subscription.lineItems.length > 0) {
              this.subscription.lineItems.forEach((rec) => {
                if (rec.type === 'IN_BUNDLE' && rec.name === 'Review Invites') {
                  this.inviteLimit = rec.qty
                }
                if (rec.type === 'IN_BUNDLE' && rec.name === 'Reviews') {
                  this.reviewLimit = this.replyLimit = rec.qty
                  if (this.subscription.name === 'Free') {
                    this.replyLimit = 3
                  }
                }
                if (rec.type === 'SUBSCRIPTION') {
                  this.subscriptionCost = rec.price
                }
              })
            }
            if (typeof this.subscription !== 'undefined' && typeof this.subscription.canPurchaseReviewsAndInvites !== 'undefined' && this.subscription.canPurchaseReviewsAndInvites) {
              console.log('here')
              this.subscriptionCanPurchaseAddOns = true
              this.subscriptionReviewCost = parseFloat(this.subscription.reviewCreditPrice)
              this.subscriptionInviteCost = parseFloat(this.subscription.inviteCreditPrice)
            }
            if (typeof data.billing_details !== 'undefined') {
              this.bForm.business_reg_name = data.billing_details.registered_name
              this.bForm.business_reg_number = data.billing_details.registration_number
              this.bForm.business_vat_number = data.billing_details.vat_number
              this.bForm.address = data.billing_details.billing_address
            }
          })
          .catch((err) => {
            console.log('err', err.response.data)
          })
    },
    nothing () {
      // nothing happening here
    }
  },
  watch: {
    getCardType (val) {
      this.cForm.selected_cc_type = ''
      const allowedCards = ['AMEX', 'MASTER', 'VISA']
      if (allowedCards.indexOf(val) !== -1) {
        this.cForm.selected_cc_type = val
      }
    },
    addOnCredits () {
      if (this.addOnInvites > 0 || this.addOnCredits > 0) {
        this.enabledPayNow = true
      } else {
        this.enabledPayNow = false
      }
    },
    addOnInvites () {
      if (this.addOnInvites > 0 || this.addOnCredits > 0) {
        this.enabledPayNow = true
      } else {
        this.enabledPayNow = false
      }
    }
  },
  computed: {
    getCardType () {
      const card = this.cForm.selected_cc_number.trim()
      if (card.length === 15 && (card.startsWith('34') || card.startsWith('37'))) {
        return 'AMEX'
      }
      if (card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))) {
        return 'MASTER'
      }
      if (card.startsWith('4') && (card.length === 13 || card.length === 16)) {
        return 'VISA'
      }
      return ''
    },
    isAmex () {
      const card = this.cForm.selected_cc_number.trim()
      return card.length === 15 && (card.startsWith('34') || card.startsWith('37'))
    },
    isVisa () {
      const card = this.cForm.selected_cc_number.trim()
      return card.startsWith('4') && (card.length === 13 || card.length === 16)
    },
    isMasterCard () {
      const card = this.cForm.selected_cc_number.trim()
      return card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))
    },
    currentPlanName () {
      if (typeof this.subscription !== 'undefined') {
        const growth = ['G1', 'G2', 'G3', 'G4']
        const premium = ['P1', 'P2', 'P3', 'P4']
        if (growth.indexOf(this.subscription.name) !== -1) {
          return 'GROWTH'
        } else if (premium.indexOf(this.subscription.name) !== -1) {
          return 'PREMIUM'
        } else if (this.subscription.subscriptionTypeId === 1) {
          return 'Account suspended. Please click edit plan to upgrade your account.'
        }
        return this.subscription.name
      }
      return ''
    },
    getLowercasePlanName () {
      if (typeof this.subscription !== 'undefined') {
        if (this.subscription.subscriptionTypeId === 1) {
          return 'g1'
        }
        return this.subscription.name.toLowerCase()
      }
      return 'g1'
    },
    getSubscriptionCycle () {
      if (typeof this.subscription !== 'undefined') {
        if (this.subscription.subscriptionTypeId === 1) {
          return 'annual'
        }
        return this.subscription.cycle
      }
      return 'annual'
    },
    getPlanRenews () {
      if (typeof this.subscription !== 'undefined') {
        const endDate = moment(this.subscription.expires).add(1, 'day').format('DD/MM/YY')
        const renews = this.isFreeTrial ? 'Ends' : 'Renews'
        if (this.subscription.subscriptionTypeId === 1) {
          return `<span class="has-text-weight-bold">&nbsp;</span>&nbsp;`
        }
        return `<span class="has-text-weight-bold">${renews}:</span>&nbsp;${endDate}`
      }
      return ''
    },
    getPlanLimits () {
      const cycle = this.subscriptionCycle === 'monthly' ? 'p.m.' : 'p.a.'
      if (typeof this.subscription !== 'undefined' && this.subscription.subscriptionTypeId === 1) {
        return ''
      }
      if (this.inviteLimit === 999999999) {
        return `Unlimited&nbsp;Review&nbsp;invites&nbsp;${cycle}&nbsp;&nbsp;|&nbsp;&nbsp;Unlimited&nbsp;review&nbsp;credits&nbsp;${cycle}&nbsp;&nbsp;|&nbsp;&nbsp;Unlimited&nbsp;reply&nbsp;credits&nbsp;${cycle}`
      }
      return `${this.inviteLimit}&nbsp;Review&nbsp;invites&nbsp;${cycle}&nbsp;&nbsp;|&nbsp;&nbsp;${this.reviewLimit}&nbsp;review&nbsp;credits&nbsp;${cycle}&nbsp;&nbsp;|&nbsp;&nbsp;${this.replyLimit}&nbsp;reply&nbsp;credits&nbsp;${cycle}`
    },
    getPlanLimitsMobile () {
      if (typeof this.subscription !== 'undefined' && this.subscription.subscriptionTypeId === 1) {
        return ''
      }
      const cycle = this.subscriptionCycle === 'monthly' ? 'p.m.' : 'p.a.'
      if (this.inviteLimit === 999999999) {
        return `Unlimited&nbsp;Review&nbsp;invites&nbsp;${cycle}<br/>Unlimited&nbsp;review&nbsp;credits&nbsp;${cycle}<br/>Unlimited&nbsp;reply&nbsp;credits&nbsp;${cycle}`
      }
      return `${this.inviteLimit}&nbsp;Review&nbsp;invites&nbsp;${cycle}<br/>${this.reviewLimit}&nbsp;review&nbsp;credits&nbsp;${cycle}<br/>${this.replyLimit}&nbsp;reply&nbsp;credits&nbsp;${cycle}`
    },
    getPlanCostAndFrequency () {
      if (typeof this.subscription !== 'undefined' && this.subscription.subscriptionTypeId === 1) {
        return ''
      }
      return `R${this.subscriptionCost}&nbsp;excl.&nbsp;vat&nbsp;/&nbsp;${this.subscriptionCycle}`
    },
    getReviewCreditTotalCost () {
      const credits = parseInt(this.addOnCredits)
      if (credits > 0) {
        const multiplier = parseInt((this.subscriptionReviewCost).toString())
        const total = credits * multiplier
        return `R${this.formatPrice(total)}`
      }
      return `R0.00`
    },
    getInviteCreditTotalCost () {
      const credits = parseInt(this.addOnInvites)
      if (credits > 0) {
        const multiplier = parseInt((this.subscriptionInviteCost).toString())
        const total = credits * multiplier
        return `R${this.formatPrice(total)}`
      }
      return `R0.00`
    },
    getBillingContactName () {
      if (typeof this.billingContact !== 'undefined') {
        return this.billingContact.name
      }
      return ''
    },
    getBillingContactEmail () {
      if (typeof this.billingContact !== 'undefined') {
        return this.billingContact.email
      }
      return ''
    },
    hasCreditCardDetails () {
      return typeof this.payment_plan !== 'undefined' && this.payment_plan.payment_method === 'CREDIT_CARD'
    },
    getCreditCardDetails () {
      if (typeof this.userInfo !== 'undefined' && typeof this.userInfo.creditCardInfo !== 'undefined' && this.userInfo.creditCardInfo !== null) {
        let _json = this.userInfo.creditCardInfo
        if (typeof _json === 'string') {
          _json = JSON.parse(this.userInfo.creditCardInfo)
        }
        return `**** **** **** ${_json.last4Digits}`
      }
      return ''
    },
    getCreditCardHolder () {
      if (typeof this.userInfo !== 'undefined' && typeof this.userInfo.creditCardInfo !== 'undefined' && this.userInfo.creditCardInfo !== null) {
        let _json = this.userInfo.creditCardInfo
        if (typeof _json === 'string') {
          _json = JSON.parse(this.userInfo.creditCardInfo)
        }
        return _json.holder
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/utilities/_colors.scss";

.neg-pad {
  margin-top: -2.25rem;
  margin-left: -20px;
  margin-right: -20px;
}

.billing-header {
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 0;
  border-bottom: solid 1px #dbdbdb;
}

.billing-section {
  margin-left: 16px;
  margin-right: 38px;
  padding: 20px 25px 20px 0;
  border-bottom: solid 1px #dbdbdb;
}

.billing-section:last-child {
  border: none;
}

.billing-section .bs-head {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: color("blue-dark");
}

.bs-link, .bs-link:hover, .bs-link:visited {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: right;
  text-decoration: underline;
  color: color("blue");
}

.billing-section p {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  color: #707070;
}

h1 {
  width: 54px;
  height: 22px;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.about {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

/*.level:not(:last-child) {*/
/*  margin-bottom: 0;*/
/*}*/

.level {
  margin-bottom: 5px;
}

.level:first-child {
  margin-bottom: 13px;
}

.input_credits {
  width: 60px;
  height: 35px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.billing-section > .level.has-input:not(:last-child) {
  margin-bottom: 11px;
}

.billing-section > .level.has-input > .level-right > .level-item:last-child > p {
  width: 75px;
}

.level-left .level-item:not(:last-child), .level-right .level-item:not(:last-child) {
  margin-right: 8px;
}

.table > thead > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.table > tbody > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.table td {
  border-bottom: solid 1px rgba(219, 219, 219, 0.4) !important;
}

.table > tbody > tr {
  background-color: #ffffff !important;
  height: 48px;
  /*margin-bottom: 10px;*/
}

/**
 * MODAL
 */

.modal-content, .modal-card {
  width: auto;
  max-width: 754px;
}

.modal-card-body {
  padding: 0 25px 35px 25px;
  overflow: visible; /* This is to ensure the dropdown menu is not cut off */
}

.modal-card-head {
  border-bottom: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 20px 25px 16px 25px;
}

.modal-card-foot {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top: none;

  padding: 0 25px 41px 25px;
}

.modal-card-head, .modal-card-foot {
  background-color: #ffffff;
}

.modal-card-title {
  font-family: 'Open Sans' !important;
  font-size: 14px !important;
  font-weight: bold !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.36 !important;
  letter-spacing: normal !important;
  color: color("blue-dark") !important;
}

.modal input[type="text"] {
  width: 341px;
  height: 35px;
  border: solid 1px #dbdbdb;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  padding-left: 15px;
  /*padding-left:18px;*/
}

.modal .delete, .modal .modal-close {
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #ffffff;
  border: none;
  border-radius: 0;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 30px;
  max-height: 30px;
  max-width: 30px;
  min-height: 30px;
  min-width: 30px;
  outline: 0;
  position: relative;
  vertical-align: top;
  width: 30px;
  padding-right: 0;
  padding-left: 0;
}

.modal .delete::before, .modal .modal-close::before {
  height: 2px;
  width: 20px;
}

.modal .delete::after, .modal .modal-close::after {
  height: 20px;
  width: 2px;
}

.modal .delete::after, .modal .delete::before, .modal .modal-close::after, .modal .modal-close::before {
  background-color: #58595b;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.mar-top-10 {
  margin-top: 10px;
}

.cc_field {
  width: 103px !important;
}

.cc_info {
  margin-right: 0 !important;
}

.modal .label {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.modal .label:not(:last-child) {
  margin-bottom: 5px;
}

.modal .field.is-grouped > .control:not(:last-child) {
  margin-right: 15px;
}

.modal .button {
  width: 130px;
  height: 35px;
}

.modal .field.is-grouped.is-grouped-multiline > .control:last-child, .modal .field.is-grouped.is-grouped-multiline > .control:not(:last-child) {
  margin-bottom: 15px;
}

.modal .rel-pos {
  right: 14px;
  position: absolute;
  top: 30px;
}

.modal .level {
  height: 35px;
  width: 341px;
  padding-left: 140px;
}

/**
 * END MODAL
 */

.modal .help.is-danger {
  color: red !important;
}

@media screen and (max-width: 767px) {

  .cc_field {
    width: 100% !important;
  }
  .billing-header {
    margin-top: 40px;
  }

  h1 {
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 25px;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    padding-left: 20px;
  }

  /*.level.is-mobile .level-item {*/
  /*  margin-right: 20px;*/
  /*}*/

  .level.is-mobile > .level-right > .level-item {
    margin-right: 10px;
  }

  .level.is-mobile > .level-right > .level-item:last-child {
    margin-right: 0;
  }

  .billing-section {
    margin-left: 36px;
    margin-right: 35px;
    padding-right: 0;
  }

  .mar-top-20 {
    margin-top: 20px;
  }

  .billing-header > .level > .level-right > .level-item {
    margin-right: 10px;
  }

  .billing-header > .level > .level-right > .level-item:last-child {
    margin-right: 20px;
  }

  .modal-card-body > form > .field > .control > .input {
    width: 100%;
  }

  .modal-card {
    width: 100%;
  }

  .modal-card-body {
    overflow-y: scroll;
  }

  .level img {
    vertical-align: middle;
  }
}

.tooltip-new {
  top: 15px;
  left: 105px;
  position: absolute;

  & > > > .tooltip__content-box {
    left: 49px;
    text-align: left;
  }

  /*Tablet view- (Ipad-Horizontal)*/
  @media screen and (min-width: 767px) and (max-width: 1000px) {
    left: 65px;
  }
  /*Tablet view- (Ipad-Vertical)*/
  @media screen and (min-width: 1024px) and (max-width: 1200px) {
    left: 88px;
  }
  /*Tablet view- (Ipad pro-Horizontal)*/
  @media screen and (min-width: 1366px) {
    left: 123px;
  }
  /*Large screens*/
  @media screen and (min-width: 1600px) {
    left: 130px;
  }
  /*Large screens*/
  @media screen and (min-width: 1900px) {
    left: 150px;
  }
  /*Large screens*/
  @media screen and (min-width: 2200px) {
    left: 190px;
  }
}

.bs-link.nothing {
  color: rgba(88, 89, 91, 0.4);
}

.dummy-msg-warning- {
  height: 40px;
  width: 100%;
  border: 1px solid #e4862c;
  color: #e4862c;
  background-color: #FEF9F4;
  display: flex;
  margin-bottom: 25px;
  flex-direction: row;
  align-items: center;
}

.dummy-msg-warning- {
  padding: 0px 0px;
}

.dummy-msg-warning- span {
  border-right: 1px solid;
  height: 100%;
  display: inline-grid;
  margin-right: 20px;
  padding: 8px 20px;
  float: left;
}

.dummy-msg-warning- p {
  font-size: 12px;
  color: #e4862c;
}


</style>



// WEBPACK FOOTER //
// src/pages/billing/new/BillingIndex.vue